export default __webpack_public_path__ + "static/media/SixtemaTinexta-Original_2022.0d2323b5.png";